import React from 'react';

const Card = ({
  children,
  className = '',
  onClick,
  hover = false,
  ...props
}) => {
  const baseClasses = 'bg-white rounded-lg shadow-md overflow-hidden';
  const hoverClasses = hover ? 'cursor-pointer transition-transform duration-200 hover:shadow-lg hover:-translate-y-1' : '';

  const classes = `${baseClasses} ${hoverClasses} ${className}`.trim().replace(/\s+/g, ' ');

  if (onClick) {
    return (
      <div onClick={onClick} className={classes} {...props}>
        {children}
      </div>
    );
  }

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Card;

